<div id="root">
  <h4>Enterprise Search</h4>
</div>

<div class="search-layout">
  <nav class="facet-rail"
       *ngIf="pills.length > 1">
    <button *ngFor="let pill of pills"
            type="button"
            class="facet"
            [class.active]="activeFilter === pill.key"
            matRipple
            (click)="setFilter(pill.key)">
      <span class="facet-badge badge-{{ pill.colorKey }}">
        <img *ngIf="pill.img"
             [src]="pill.img"
             class="facet-img"
             alt="" />
        <fa-icon *ngIf="!pill.img && pill.icon"
                 [icon]="pill.icon"></fa-icon>
      </span>
      <span class="facet-label">{{ pill.label }}</span>
      <span class="facet-count">{{ pill.count }}</span>
    </button>
  </nav>

  <div class="results-pane">
    <div class="waiting"
         *ngIf="isSearching">
      <i class="fa fa-circle-o-notch fa-spin fa-fw fa-lg"></i>
    </div>

    <div class="search-result"
         *ngIf="!isSearching">
      <div class="sp-error"
           *ngIf="sharePointError && (activeFilter === 'All' || (activeFilter !== 'CUB' && activeFilter !== 'Egnyte'))">
        <fa-icon [icon]="spIcon"></fa-icon>
        {{ sharePointError }}
      </div>
      <div class="no-results"
           *ngIf="sections.length === 0">
        No results found.
      </div>

      <mat-accordion multi
                     *ngIf="sections.length > 0">
        <mat-expansion-panel *ngFor="let section of sections"
                             class="result-section"
                             [expanded]="true">
          <mat-expansion-panel-header collapsedHeight="52px"
                                      expandedHeight="52px">
            <mat-panel-title class="section-title">
              <span class="facet-badge badge-{{ section.colorKey }}">
                <img *ngIf="section.img"
                     [src]="section.img"
                     class="facet-img"
                     alt="" />
                <fa-icon *ngIf="!section.img && section.icon"
                         [icon]="section.icon"></fa-icon>
              </span>
              <span class="section-label">{{ section.label }}</span>
            </mat-panel-title>
            <mat-panel-description class="section-count">
              {{ section.count }} {{ section.count === 1 ? 'result' : 'results' }}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- Lease Files: nested lease -> folder grouping -->
          <ng-container *ngIf="section.leases; else flatList">
            <mat-accordion multi>
              <mat-expansion-panel *ngFor="let lease of section.leases"
                                   class="lease-panel"
                                   [expanded]="false">
                <mat-expansion-panel-header collapsedHeight="54px"
                                            expandedHeight="54px">
                  <mat-panel-title class="lease-title">
                    <fa-icon [icon]="folderIcon"
                             class="lease-icon"></fa-icon>
                    <span class="lease-label">{{ lease.name }}</span>
                  </mat-panel-title>
                  <mat-panel-description class="section-count">
                    {{ lease.count }} {{ lease.count === 1 ? 'result' : 'results' }}
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <ng-container *ngFor="let folder of lease.folders">
                  <div class="folder-subheader"
                       *ngIf="folder.name">
                    <fa-icon [icon]="folderIcon"></fa-icon>
                    <span>{{ folder.name }}</span>
                  </div>
                  <ng-container *ngTemplateOutlet="rowList; context: { $implicit: folder.results }"></ng-container>
                </ng-container>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>

          <!-- Everything else: flat list -->
          <ng-template #flatList>
            <ng-container *ngTemplateOutlet="rowList; context: { $implicit: section.results }"></ng-container>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Reusable list of result rows -->
      <ng-template #rowList
                   let-items>
        <mat-list>
          <ng-container *ngFor="let result of items; let last = last">
            <mat-list-item class="result-row"
                           matRipple
                           (click)="itemClick(result)">
              <div class="row-icon source-{{ result.source }}"
                   [class.logo-badge]="rowLogo(result)"
                   matListItemAvatar>
                <img *ngIf="rowLogo(result) as logo"
                     [src]="logo"
                     class="row-logo"
                     alt="" />
                <fa-icon *ngIf="!rowLogo(result)"
                         [icon]="iconFor(result)"></fa-icon>
              </div>

              <div matListItemTitle
                   class="row-title">{{ result.title }}</div>

              <div matListItemLine
                   class="row-subtitle">{{ result.subtitle }}</div>

              <div matListItemLine
                   *ngIf="result.snippet"
                   class="row-snippet"
                   [innerHTML]="result.snippet"></div>
            </mat-list-item>
            <mat-divider *ngIf="!last"></mat-divider>
          </ng-container>
        </mat-list>
      </ng-template>
    </div>
  </div>
</div>
